import React, { useState, useEffect }  from 'react';
import {Link} from 'react-router-dom';
import styled from 'styled-components';
import { IconsWrap } from './StyledComponents/StyledComp';

import {BsLinkedin, BsGithub} from 'react-icons/bs';
import {SiLeetcode} from 'react-icons/si';
import Drawer from './Drawer';

function Navbar() {

  const [colorClass, setColorClass]= useState("");
  const [borderClass, setBorderClass]= useState("");

  const [open, setOpen] = useState(false);

  const changeColor = ()=>{
    // console.log(window.scrollY);
    if(window.scrollY>window.innerHeight){
      setColorClass("dark-color");
      setBorderClass("dark-border");
    }else{
      setColorClass("");
      setBorderClass("light-border");
    }
  }

  useEffect(()=>{
    changeColor();
    window.addEventListener("scroll", changeColor);
  });

  return (
    <Navwrapper>

      {open && (
        <Drawer setOpen={setOpen} />
      )}

        <div className="left-section">
          <Link to="/" ><p className={`title-lead clickable ${colorClass} `} >Devansh Batra</p></Link>
        </div>

        <div className='rightsection'>
          <IconsWrap  className='icons' >
            <a href="https://www.linkedin.com/in/devansh-batra-9999a6191/" target='_blank' ><li className={`clickable ${colorClass} `}  ><BsLinkedin size={25} /></li></a>
            <a href="https://github.com/devanshbatra" target='_blank' ><li className={`clickable ${colorClass} `} ><BsGithub size={25} /></li></a>
            <a href="https://leetcode.com/devanshbatra/" target='_blank' ><li className={`clickable ${colorClass}`}  ><SiLeetcode size={25} /></li></a>
          </IconsWrap>
          <div className="hamburger clickable " onClick={()=>setOpen(!open)} >
            <div className={`line1 ${borderClass} `}></div>
            <div className={`line2 ${borderClass} `}></div>
          </div>
        </div>
    </Navwrapper>
  );
}

const Navwrapper = styled.div`
  position: fixed;
  width: 100%;
  top: 0px;
  display: flex;
  padding: 2rem 2rem;
  align-items: center;
  z-index: 1000;
  justify-content: space-between;

  .dark-color{
    color: #353636;
    text-shadow: none;  
  }

  .dark-border{
    border-bottom: 3.5px solid #353636;
  }

  .light-border{
    border-bottom: 3.5px solid var(--white);
  }

  .rightsection{
    display: flex;
    align-items: center;
  }

  .hamburger{
    margin: 0 1rem 0 2rem;
  }
  .line1{
    width: 3.4rem;
    margin-bottom: 0.8rem;
  }
  .line2{
    width: 3.4rem;
  }

  @media only screen and (max-width: 500px){
    .line1{
      width: 2.5rem;
      margin-bottom: 0.5rem;
    }
    .line2{
      width: 2.5rem;
    }
    .icons{
      display: none;
    }
  }

`;



export default Navbar;